import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import axios from "axios";
import { config } from "../../config";
import "./DetailFasilitas.scss";
import FeatherIcon from "feather-icons-react";
import LoadingOverlay from "../../component/LoadingOverlay";

const DetailFasilitas = () => {
  const { id } = useParams();
  const history = useHistory();
  const [fasilitas, setFasilitas] = useState(null);
  const [fasilitasDetail, setFasilitasDetail] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const handleBackClick = (e) => {
    e.preventDefault();
    history.push("/");
    setTimeout(() => {
      const element = document.getElementById("galery");
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          `${config.BASE_URL}fasilitas/webFindOne/${id}`
        );
        const data = res.data.data;
        setFasilitas(data.fasilitas);
        setFasilitasDetail(data.fasilitasDetail || []);
      } catch (err) {
        console.error("Error fetching fasilitas:", err);
        setError("Gagal memuat data fasilitas.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  if (loading) {
    return (
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <LoadingOverlay />
        <p style={{ color: "#F1582E", marginTop: "10px", fontWeight: "bold" }}>
          Harap Tunggu Sesaat...
        </p>
      </div>
    );
  }

  if (error) return <p>{error}</p>;

  return (
    <section id="DetailFasilitas">
      <div className="navbar">
        <a href="#" onClick={handleBackClick} className="link-back">
          <FeatherIcon icon="arrow-left" />
          Kembali
        </a>
      </div>

      <div className="container">
        <div className="news-content">
          <h2>{fasilitas?.nama}</h2>

          <p className="news-date">
            {new Date(fasilitas?.tanggalRelease).toLocaleDateString("id-ID", {
              weekday: "long",
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </p>

          {fasilitasDetail.length > 0 ? (
            <div className="galeri-foto">
              {fasilitasDetail.map((item, index) => (
                <img
                  key={index}
                  src={
                    item.foto
                      ? `${
                          config.BASE_URL
                        }getReferenceFile?pathFile=${encodeURIComponent(
                          item.foto
                        )}`
                      : "/assets/images/default.png"
                  }
                  alt={`Foto ${index + 1}`}
                  className="galeri-foto-item"
                />
              ))}
            </div>
          ) : (
            <p style={{ textAlign: "center", marginTop: "20px" }}>
              Tidak ada gambar tersedia.
            </p>
          )}

          <p className="news-description">{fasilitas?.keterangan}</p>
        </div>
      </div>
    </section>
  );
};

export default DetailFasilitas;
